module.exports.AddImageMode = require('./AddImageMode.js');
module.exports.AddTextMode = require('./AddTextMode.js');
module.exports.AddTickBoxMode = require('./AddTickBoxMode.js');
module.exports.BoxDrawMode = require('./BoxDrawMode.js');
module.exports.InteractionMode = require('./InteractionMode.js');
module.exports.SelectionMode = require('./SelectionMode.js');